/**
 * @ngdoc directive
 * @name phoenix.directive:pxContenteditable
 * @module phoenix
 * @restrict A
 * @description
 *
 * Allows a div to be content editable via the ngModel
 *
 * @usage
 *
 * <div contenteditable ng-model='ctrl.text' />
 *
 */
export function ContentEditableDirective() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function (scope, element, attrs, ngModel) {

			function read() {
				ngModel.$setViewValue(element.html());
			}

			ngModel.$render = function () {
				element.html(ngModel.$viewValue || '');
			};

			element.bind('blur keyup change', function () {
				scope.$apply(read);
			});
		}
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/components/contentEditable/contentEditable.ts